export default class Button {

  constructor() {
    this.footer = document.querySelector('.footer-dk');
    this.buttonBackToTop = document.querySelector('.button-up');
    this.buttonUpPage = document.querySelector('.button-up-page');
    this.delay = 1;
  }

  _checkPageOffset() {
    window.pageYOffset > 500
      ? this.buttonUpPage.classList.add('button-up-page--active')
      : this.buttonUpPage.classList.remove('button-up-page--active');

    this.footer.getBoundingClientRect().y < this.buttonBackToTop.offsetTop + 20
      && this.buttonUpPage.classList.remove('button-up-page--active');
  }

  _backToTop() {
    const scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      pos > 0
        ? window.scrollTo(0, pos - 100)
        : window.clearInterval(scrollToTop);
    }, 15);
  }

  init() {

    if (this.buttonBackToTop) {
      this.buttonBackToTop.addEventListener('click', () => this._backToTop());
      window.addEventListener('scroll', () => this._checkPageOffset());
    }

  }
}
